import React from 'react';
import {
    Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { Table, Th, Thead, Tr, Td} from 'reactable';
import { appHelpers } from '../../_helpers';

import IconMdFlightTakeoff from 'react-icons/lib/md/flight-takeoff';
import IconMdFlightLand from 'react-icons/lib/md/flight-land';

class ManifestDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            details: this.props.details,
            manifest: this.props.info
        }
    }
    
    render() {
        const {isOpen, toggle, modalClass, modalResponse, downloadManifest} = this.props;
        const { details, manifest } = this.state;
        return (
        <Modal size={'lg'} isOpen={isOpen} toggle={toggle} className={modalClass}>
            <ModalHeader toggle={toggle}>Manifest Details</ModalHeader>
                <ModalBody>
                    { modalResponse }
                    <Container>
                        <Row>
                            <Col>
                                   <blockquote className="blockquote md-5" style={{ width: '100%!important'}}>
                <h5 className="mb-2">{`${manifest.AirlineName} : ${manifest.FlightNumber}`}</h5>
                <div> <IconMdFlightTakeoff size="18" color="#000000"/>{`${manifest.DepartureAirportName}`} || <IconMdFlightLand size="18" color="#000000"/> {`${manifest.DestinationAirportName}`}</div>
                <div>
                <a color="info" size="sm" className="btn btn-avi-primary" onClick={downloadManifest}>Download</a>
                </div>
                </blockquote>
                            </Col>
                        </Row>
                            <Col className="mt-3">
                                <Table className="table table-striped table-hover" id="table" sortable={true} itemsPerPage={8} pageButtonLimit={10} >
                                    <Thead>
                                        <Th column="TicketNumber">
                                            <span>Ticket Number</span>
                                        </Th>
                                        <Th column="FullName">
                                            <span>Passenger Name</span>
                                        </Th>
                                        <Th column="TSCCharge">
                                            <span>Ticket Sales Charge (TSC)</span>
                                        </Th>
                                        <Th column="BasicFare">
                                            <span>Fare (Basic)</span>
                                        </Th>
                                        <Th column="TotalFare">
                                            <span>Fare (Total)</span>
                                        </Th>
                                    </Thead>
            
                                {details.Results.map((passenger, i) => <Tr key={passenger.PassengerId}>
                                    <Td column="TicketNumber" className="text-capitalize">{passenger.TicketNumber}</Td>
                                    <Td column="FullName">{passenger.FullName}</Td>
                                    <Td column="TSCCharge" className="text-capitalize">{appHelpers.numberWithCommas(passenger.TSCCharge)}</Td>
                                    <Td column="BasicFare">{appHelpers.numberWithCommas(passenger.BasicFare)}</Td>
                                    <Td column="TotalFare" className="text-capitalize">{appHelpers.numberWithCommas(passenger.TotalFare)}</Td>
                                </Tr>)}
                            </Table>
                        </Col>
                    <Row>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
        </Modal>
    )
    }
}

export default ManifestDetails;


// WEBPACK FOOTER //
// ./src/views/search/manifest.details.js